import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./index.css";
import { TravelWidget } from "./components/travelWidget";

const roots = document.querySelectorAll(".carousel-root");
roots.forEach((element) => {
  ReactDOM.render(<TravelWidget />, element);
});
